module.exports = __webpack_public_path__ + "static/vicki-b4e03e3d6717b934a40a6a695efbeb1b.jpg";